import { ValueType } from '@convergence/types';

export function valueFromTreeAndPath<T = unknown>(
  tree: ValueType,
  path: string[]
): T | undefined {
  let current: any = tree;
  for (const p of path) {
    current = current?.[p];
  }

  return current?._value as T | undefined;
}

export function deepClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj)) as T;
}

export function getError(
  errors: { message: string; keyPath: string[] }[],
  propertyPath: string[]
) {
  return errors.find((e) => e.keyPath.join() === propertyPath.join());
}
